<mat-accordion class="example-headers-align" multi>
  <mat-expansion-panel>
    
    <mat-expansion-panel-header>
      <div class="col-md-11"> {{ checklist?.checklist_name }}</div>
      <!-- <mat-panel-title> </mat-panel-title> -->
      <!-- <mat-panel-description>
        <div>{{ checklist?.agency }}</div>
      </mat-panel-description> -->
    <div class="col-md-1">
        <div style="text-align: start;">{{ checklist?.frequency }}</div>
    </div>
    </mat-expansion-panel-header>
    <div class="content">
      <div class="card">
        <div class="subContent">
          <div class="card">
            <div class="checklist-title">
              {{ checklist?.checklist_name }}
            </div>
            <!-- <div *ngIf="checklist.view_type == 'defect_sheet'" style="float: right;">
              <button
              type="button"
              class="btn btn-default createBtn"
              (click)="getNewChecklist(checklist)"
            >
              New
            </button>
            </div> -->
            <div class="row">
              <div class="col-3">
                <span class="label-color">Category : </span>
                {{ checklist.category }}
              </div>
              <!-- <div class="col-3">
                <span class="label-color">Section : </span>
                {{ checklist.agency }}
              </div>
              <div class="col-3">
                <span class="label-color">Area : </span> {{ checklist.area }}
              </div>
              <div class="col-3">
                <span class="label-color">Frequency: </span>
                {{ checklist.frequency }}
              </div> -->
            </div>
            <div
              class="row"
              style="margin-top: 20px"
              *ngIf="checklist.metaData"
            >
              <ng-container *ngFor="let data of checklist.metaData">
                <div *ngIf ="data.columnName != 'Model' && data.columnName != 'Shift'" class="col" style="display: grid; margin: 5px 5px">
                  <span class="label-color">{{ data.columnName + '*' }} : </span>
                  <input type="text" [(ngModel)]="data.value" />
                </div>
                <div *ngIf ="data.columnName == 'Model'" class="col" style="display: grid; margin: 5px 5px">
                  <span class="label-color">{{ data.columnName + '*' }} : </span>
                  <app-dropdown
                  [values]="modalDropdownList"
                  [selected]=""
                  [displayMember]="'text'"
                  (newSelectionEvent)="updateMetaData($event,checklist,data,'model')"
                  type="object"
                >
                </app-dropdown>
                </div>
                <div *ngIf ="data.columnName == 'Shift'" class="col" style="display: grid; margin: 5px 5px">
                  <span class="label-color">{{ data.columnName + '*' }} : </span>
                  <app-dropdown
                  [values]="shiftList"
                  [selected]=""
                  (newSelectionEvent)="updateMetaData($event,checklist,data,'shift')"
                >
                </app-dropdown>
                </div>
              </ng-container>
              
            </div>
            <!-- <div class="card" *ngFor="let point of checklist.check_points">
              <div class="row description">
                <div class="col-12 normDetail">
                  <div class="label">Description</div>
                  <div class="value">
                    {{ point.description }}
                  </div>
                </div>
              </div>
              <div class="row rowTop">
                <div class="col-4 normDetail">
                  <div class="label">Equipment Name</div>
                  <div class="value">{{ point?.equipment.equipmentName }}</div>
                </div>
                <div class="col-3 normDetail">
                  <div class="label">Standard Norm</div>
                  <div class="value">{{ point?.standard_norm }}</div>
                </div>
                <div class="col-3 criticalityDetail">
                  <div class="label">Criticality</div>
                  <div class="value">{{ point?.criticality }}</div>
                </div>
                <div class="col-2 actionBtn">
                  <app-dropdown
                    [values]="ackData"
                    [selected]="selectedAck"
                    [displayMember]="'name'"
                    (newSelectionEvent)="point['ack'] = $event['value']"
                    type="object"
                  >
                  </app-dropdown>
                </div>
              </div>
              <div class="row rowBottom">
                <div class="col-3">
                  <div class="row h-100">
                    <div class="col label">Action Taken:</div>
                    <div class="col">
                      <input type="text" [(ngModel)]="point['action_taken']" />
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <div class="row h-100">
                    <div class="col-6">
                      <div class="row h-100">
                        <div class="col-2 label padLeft0">Observation:</div>
                        <div class="col-10 input">
                          <input
                            type="text"
                            [(ngModel)]="point['observations']"
                            class="wid100"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row h-100">
                        <div class="col-2 label">Remarks:</div>
                        <div class="col-10 input">
                          <input
                            type="text"
                            [(ngModel)]="point['remarks']"
                            class="wid100"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- {{checklist.headerColumns|json}}
            {{checklist.check_points|json}} -->
            <ng-container *ngIf="checklist.view_type == 'pictorial'">
              <div class="row">
                <ng-container *ngFor="let data of checklist.pictorialData">
                  <div
                    [ngClass]="data.grid"
                    style="position: relative; text-align: center"
                  >
                    <img [src]="data.img_src" alt="" />
                    <ng-container *ngFor="let element of data.data">
                      <div style="position: relative">
                        <span
                          class="shift-card"
                          [ngStyle]="{ top: element.top, left: element.left }"
                        >
                          <div
                            style="
                              text-align: center;
                              color: #2a7cf6;
                              background-color: #c9dfff;
                            "
                          >
                            {{ element.data_id }}
                          </div>
                          <div style="width: 100%; display: flex; height: 22px">
                            <div
                              style="
                                width: 30%;
                                border-bottom: 1px solid #d8d8d8;
                                border-top: 1px solid #d8d8d8;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="borders"
                            >
                              A
                            </div>
                            <div style="width: 70%">
                              <input
                                type="text"
                                style="
                                  border-radius: 0px;
                                  height: 22px;
                                  color: #417cf7;
                                "
                                [(ngModel)]="element.Shift_A"
                              />
                            </div>
                          </div>
                          <div style="width: 100%; display: flex; height: 22px">
                            <div
                              style="
                                width: 30%;
                                border-bottom: 1px solid #d8d8d8;
                                border-top: 1px solid #d8d8d8;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="borders"
                            >
                              B
                            </div>
                            <div style="width: 70%">
                              <input
                                type="text"
                                style="
                                  border-radius: 0px;
                                  height: 22px;
                                  color: #417cf7;
                                "
                                [(ngModel)]="element.Shift_B"
                              />
                            </div>
                          </div>
                          <div style="width: 100%; display: flex; height: 22px">
                            <div
                              style="
                                width: 30%;
                                border-bottom: 1px solid #d8d8d8;
                                border-top: 1px solid #d8d8d8;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="borders"
                            >
                              C
                            </div>
                            <div style="width: 70%">
                              <input
                                type="text"
                                style="
                                  border-radius: 0px;
                                  height: 22px;
                                  color: #417cf7;
                                "
                                [(ngModel)]="element.Shift_C"
                              />
                            </div>
                          </div>
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="checklist.view_type == 'defect_sheet'">
              <div class="row">
                <ng-container *ngFor="let data of checklist.defectData; let i = index">
                  <div
                    [ngClass]="data.grid"
                    id = '{{checklist.checklist_name + i}}'
                    style="position: relative; text-align: center;margin-top: 40px;
                    "
                  >
                    <img [id] = "checklist.checklist_name" (click)="getClick($event, checklist, coordinateSetting, checklist.checklist_name + i)" [src]="data.img_src" alt="" />
                    <ng-container *ngFor="let element of data.data">
                      <span style="position: absolute"[ngStyle]="{ top:element.top,left: element.left }">
                        <span
                          class="defect-codes"
                          
                        >
                          <span>{{formatDefects(element.defects,'onImage')}}</span>
                        </span>
                      </span>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf = "checklist.view_type == 'defect_sheet' && checklist.defectData[0].data.length">
              <table id="alerts">
                <tr class="header">
                  <th>
                    Part
                  </th>
                  <th>
                    Location
                  </th>
                  <th>
                    Defects
                  </th>
                  <th>Actions</th>
                </tr>
                <ng-container *ngFor="let data of checklist.defectData[0].data; let i = index">
                  <tr>
                    <td>
                      {{data.part}}
                    </td>
                    <td>
                      {{data.location}}
                    </td>
                    <td>{{formatDefects(data.defects,'table')}}</td>
                    <td>
                      <i
                class="fa fa-pencil icon editUserbtn action-btn"
                title="Edit user info"
                (click) = "popupOpen(coordinateSetting, 'defect','edit',data, i, checklist.cabinType)"
              ></i>
              <i
                class="fa fa-trash icon deleteUserBtn action-btn"
                title="Delete"
                (click) = "deleteDefect(checklist.defectData[0].data, i)"
              ></i>
                    </td>
                  </tr>
              </ng-container>
              </table>
              
            </ng-container>
            
            <table *ngIf="checklist.headerColumns.length" id="alerts">
              <tr class="header">
                <th *ngFor="let header of datatable.header">
                  {{ header.columnName }}
                </th>
                <th>Actions</th>
              </tr>
              <ng-container
                *ngFor="let point of checklist.check_points; let i = index"
              >
                <ng-container *ngIf="point.header">
                  <div class="headerTextStyle">{{ point.header }}</div>
                </ng-container>
                <ng-container *ngIf="!point.header">
                  <tr class="acc pointHead">
                    <td *ngFor="let header of datatable.header">
                      <!-- <ng-container *ngIf="header.columnType == 'Dropdown'">
                        {{
                          point[header.columnId][header.dropdownCategory.display]
                        }}
                      </ng-container> -->
                      <ng-container
                        *ngIf="
                          header.columnType == 'Textbox' ||
                          header.columnType == 'Dropdown'
                        "
                      >
                        {{ checkDataType(point[header.columnId]) }}
                      </ng-container>
                    </td>
                    <td style="width: 5%" (click)="[toggleFunc(i)]">
                      <i class="fa fa-angle-down" *ngIf="!activeField[i]"></i>
                      <i class="fa fa-angle-up" *ngIf="activeField[i]"></i>
                    </td>
                  </tr>
                  <tr
                    *ngIf="datatable.inputData.length"
                    class="acc-panel pointBody"
                    [ngClass]="!activeField[i] ? 'active' : 'inactive'"
                  >
                    <td colspan="7">
                      <div class="acc-expand">
                        <div
                          class="innerlist row"
                          style="align-items: baseline !important"
                        >
                          <div
                            class="col"
                            *ngFor="let field of datatable.inputData"
                          >
                            <!-- <pre>{{field|json}}</pre> -->
                            <label>{{ field["columnName"] }}</label>
                            <ng-container
                              *ngIf="field['columnType'] == 'Textbox'"
                            >
                              <input
                                type="text"
                                class="wid100"
                                [(ngModel)]="point[field.columnId]"
                              />
                            </ng-container>
                            <ng-container
                              *ngIf="field['columnType'] == 'Dropdown'"
                            >
                              <ng-container
                                *ngIf="
                                  field['dropdownCategory'].type ==
                                  'arrayString'
                                "
                              >
                                <app-dropdown
                                  [values]="
                                    dropdownCategory[
                                      field['dropdownCategory']['label']
                                    ].value
                                  "
                                  [selected]="
                                    point[field.columnId] ||
                                    dropdownCategory[
                                      field['dropdownCategory']['label']
                                    ].value[0]
                                  "
                                  (newSelectionEvent)="
                                    point[field.columnId] = $event
                                  "
                                >
                                </app-dropdown>
                              </ng-container>
                              <ng-container
                                *ngIf="
                                  field['dropdownCategory'].type ==
                                  'arrayObject'
                                "
                              >
                                <app-dropdown
                                  [values]="
                                    dropdownCategory[
                                      field['dropdownCategory']['label']
                                    ].value
                                  "
                                  [selected]="point[field.columnId]"
                                  (newSelectionEvent)="
                                    point[field.columnId] = $event
                                  "
                                  type="object"
                                  [displayMember]="
                                    field['dropdownCategory']['display']
                                  "
                                >
                                </app-dropdown>
                              </ng-container>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </table>
          </div>
        </div>
        <div style="display: flex; justify-content: end">
          <button
            type="button"
            class="btn btn-default createBtn"
            (click)="submitChecklist(checklist)"
          >
            Submit
          </button>
           <!-- <button
            type="button"
            (click)="editChecklist(checklist)"
            style="margin-right: 10px"
            class="btn btn-default createBtn"
          >
            Add Points
          </button>  -->
          <!-- <button
            *ngIf="checkAction('Delete Checklist')"
            type="button"
            (click)="deleteChecklist(checklist)"
            style="
              margin-right: 10px;
              background-color: transparent !important;
              color: #595959 !important;
            "
            class="btn btn-secondary btn-outline createBtn"
          >
            Delete Checklist
          </button>  -->
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<ng-template #coordinateSetting let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="modal-basic-title">Defect Update Model</h6>
        <i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('Cross click')" ></i>
      </div>
      <form
      [formGroup]="defectForm"
      (ngSubmit)="addDefect(defectForm)"
    >
      <div class="modal-body coordinatesSettingContent">
       
        <div class="row">
          <div class="col-6">
            <p>Parts *</p>
            <app-dropdown
              [values]="partsList"
              [disabled] = "edit"
              [selected] = "selectedPart"
              (newSelectionEvent)="changeParts($event)"
            ></app-dropdown>
          </div>
          <div class="col-md-6" style="text-align: center;">
            <img *ngIf = "selectedPartImage && selectedPartImage != ''" style="width: 200px; height:100px" [src]="selectedPartImage" alt="">
          </div>
         
        </div>
        <div class="row" style="    margin-top: 15px;">
          <div class="col-6">
            <p>Location *</p>
            <app-dropdown
                [values]="locationList"
                [selected]="selectedLocation"
                [disabled] = "edit"
                (newSelectionEvent)="changeLocation($event)"
              >
              </app-dropdown>
          </div>
          <div class="col-md-6">
            <p>Defects</p>
            <app-searchable-dropdown
              [values]="defectsList"
              [displayMember]="'name'"
              [selected]="selectedDefects"
              [maxTags]="17"  
              (newSelectionEvent)="selectDefects($event)"
              [isMultiple]="true"
            ></app-searchable-dropdown>
          </div>

        </div>
      </div>
      <div *ngIf = "!checkObjLen('defectsCount')" style=" height: 100px; padding: 20px; font-size: 18px;
        font-family: 'sfpro-r';">
          <app-message [message]="'No Defects'"></app-message>
        </div>
      <ng-container *ngIf = "checkObjLen('defectsCount')">
      <div style="padding: 10px 20px;
      height: 150px; overflow-y: auto;">
       
          <div style="    display: flex;
          width: 100%;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;">
          <ng-container *ngFor ="let data of defectsCount | keyvalue">
            <div style="
            margin: 5px 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 95px;
        ">
              <span>{{data.key}} : </span>
              <input type="number" min="1" style="    width: 50px;" [ngModelOptions]="{standalone: true}" [(ngModel)] = "data.value.count">
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

      <div class="modal-footer">
        <button
          type="submit"
          [disabled] = "!defectForm.valid"
          class="btn btn-info"
        >
          <i class="fa fa-save"></i> Save
        </button>
      </div>
    </form>
    </div>
  
